import { __rest } from "tslib";
import React from 'react';
import { Link } from 'react-router-dom';
const ReactLink = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Link, Object.assign({}, props), children));
};
export default ReactLink;
//# sourceMappingURL=ReactLink.js.map